import { render } from "./DocumentsView.vue?vue&type=template&id=94068194&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"

import "./DocumentsView.vue?vue&type=style&index=0&id=94068194&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94068194"]])

export default __exports__